import CantileverTheme from 'styles/cantileverTheme'

export const EXPLORER_GRAY = CantileverTheme.colors.grayscale[600]
export const EXPLORER_BORDER_GRAY = CantileverTheme.colors.grayscale[400]
export const EXPLORER_BORDER_GRAY_LOW_OPACITY = 'rgba(153,153,153,0.35)'
export const EXPLORER_INPUT_GRAY = 'rgba(40,40,40,1)'
export const EXPLORER_TABLE_ROW_BACKGROUND = EXPLORER_GRAY
export const EXPLORER_HEADER_COLOR = CantileverTheme.colors.grayscale[600]
export const EXPLORER_HIGHLIGHT_COLOR = CantileverTheme.colors.grayscale[500]
export const EXPLORER_LIGHT_GREEN = '#A8E6A2'
export const EXPLORER_CHART_BLUE = 'rgba(53,120,191,1)'
